import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function CirugiaVeterinariaAlmeria() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-600 to-teal-800 text-white py-24">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            <strong>Cirugía Veterinaria Almería</strong> - Servicio Móvil Especializado
          </h1>
          <p className="text-xl text-teal-100 max-w-3xl leading-relaxed mb-8">
            <strong>Cirujano veterinario en Almería</strong> con más de 25 años de experiencia. Servicio móvil de <strong>cirugía veterinaria especializada</strong> en tu clínica: traumatología, oncología, neurocirugía y tejidos blandos.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="/#contacto"
              className="inline-flex items-center justify-center space-x-2 bg-white text-teal-700 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              <span>Solicitar Valoración</span>
            </a>
            <a
              href="https://wa.me/34600581975"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center space-x-2 bg-green-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-green-600 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span>WhatsApp 24h</span>
            </a>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                <strong>Especialista en Cirugía Veterinaria</strong> en Almería
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                Como <strong>cirujano veterinario en Almería</strong>, ofrezco un servicio móvil completo que lleva la <strong>cirugía veterinaria especializada</strong> directamente a tu clínica en <strong>Almería, Roquetas de Mar, El Ejido, Aguadulce</strong> y toda la provincia.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                Con más de <strong>25 años de experiencia</strong> y casi <strong>5000 cirugías realizadas</strong>, me especializo en procedimientos complejos de <strong>traumatología veterinaria, oncología, neurocirugía</strong> y cirugía de tejidos blandos.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Mi servicio de <strong>cirugía veterinaria móvil en Almería</strong> permite que tu clínica ofrezca procedimientos especializados sin necesidad de derivar a tus pacientes, manteniendo la continuidad del cuidado.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/12986e7ef463da4499f219f4c9173dfe.jpg"
                alt="Cirujano veterinario Almería realizando cirugía especializada con equipamiento avanzado"
                title="Cirugía veterinaria especializada Almería - Dr. Pablo Conejero"
                className="w-full h-[500px] object-cover object-top rounded-2xl shadow-2xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              <strong>Servicios de Cirugía Veterinaria</strong> en Almería
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              <strong>Cirugía veterinaria especializada</strong> en tu clínica de <strong>Almería</strong> con equipamiento de última generación
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-heart-pulse-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Traumatología TPLO</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Cirugía TPLO, fracturas, luxaciones y displasias en <strong>Almería</strong>
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-microscope-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Oncología Veterinaria</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Resección de tumores y cirugía reconstructiva especializada
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-brain-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Neurocirugía</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Hernias discales y compresiones vertebrales
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-200 hover:-translate-y-1">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-stethoscope-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Tejidos Blandos</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Cirugía torácica, abdominal y procedimientos avanzados
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
            ¿Por Qué Elegir Mi <strong>Servicio de Cirugía Veterinaria</strong> en Almería?
          </h2>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-hospital-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Servicio Móvil</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Llevo todo el equipamiento quirúrgico a tu clínica en <strong>Almería</strong>, sin necesidad de derivar pacientes
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-award-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>25 Años de Experiencia</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Más de 5000 cirugías realizadas como <strong>especialista veterinario en Almería</strong> y toda España
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-24-hours-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                <strong>Disponibilidad 24h</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Atención de urgencias y valoraciones en <strong>Almería</strong> y provincia las 24 horas
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Coverage Area */}
      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              <strong>Cobertura en Almería</strong> y Provincia
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Servicio de <strong>cirugía veterinaria móvil</strong> en toda la provincia de <strong>Almería</strong>
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              'Almería Capital',
              'Roquetas de Mar',
              'El Ejido',
              'Aguadulce',
              'Adra',
              'Níjar',
              'Vera',
              'Huércal-Overa',
              'Carboneras',
              'Vícar',
              'Huércal de Almería',
              'Cuevas del Almanzora',
              'Berja',
              'Albox',
              'Pulpí',
              'Garrucha'
            ].map((ciudad, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-4 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-teal-200"
              >
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-2-fill text-teal-600"></i>
                  </div>
                  <span className="font-semibold text-gray-900">{ciudad}</span>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <a
              href="/zonas-de-servicio"
              className="inline-flex items-center space-x-2 text-teal-600 hover:text-teal-700 font-semibold cursor-pointer"
            >
              <span>Ver todas las zonas de servicio</span>
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-teal-600 to-teal-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            ¿Necesitas un <strong>Cirujano Veterinario</strong> en Almería?
          </h2>
          <p className="text-xl text-teal-100 mb-8 leading-relaxed">
            Contacta conmigo para una valoración profesional o segunda opinión. Servicio de <strong>cirugía veterinaria especializada</strong> en tu clínica de <strong>Almería</strong>.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/#contacto"
              className="inline-flex items-center justify-center space-x-2 bg-white text-teal-700 px-8 py-4 rounded-lg font-semibold hover:bg-teal-50 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              <span>Solicitar Valoración</span>
            </a>
            <a
              href="tel:+34600581975"
              className="inline-flex items-center justify-center space-x-2 bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-900 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>Llamar: 600 581 975</span>
            </a>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Teléfono</h3>
              <a href="tel:+34600581975" className="text-teal-600 hover:text-teal-700 cursor-pointer">
                +34 600 581 975
              </a>
            </div>
            <div>
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Email</h3>
              <a href="mailto:vetconejero@gmail.com" className="text-teal-600 hover:text-teal-700 cursor-pointer">
                vetconejero@gmail.com
              </a>
            </div>
            <div>
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Ubicación</h3>
              <p className="text-gray-600">Almería, Andalucía</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}